import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { ArrowLeft, User, Mail, Terminal } from 'lucide-react';
import { toast } from 'sonner';

export default function SettingsPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="settings-page">
      <nav className="sticky top-0 z-50 backdrop-blur-xl bg-black/40 border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center">
          <Button variant="ghost" size="sm" className="text-white/50 hover:text-white" onClick={() => navigate('/dashboard')}>
            <ArrowLeft className="w-4 h-4 mr-1.5" /> Dashboard
          </Button>
          <span className="ml-4 text-sm text-white/40">/ Settings</span>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-8">
        <h1 className="text-3xl font-bold text-white tracking-tight mb-8" style={{fontFamily: 'Space Grotesk, sans-serif'}} data-testid="settings-title">
          Settings
        </h1>

        <Card className="bg-white/[0.03] border-white/10 mb-6" data-testid="profile-card">
          <CardHeader>
            <CardTitle className="text-white text-lg">Profile</CardTitle>
            <CardDescription className="text-white/40">Your account information</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label className="text-white/60 text-sm">Name</Label>
              <Input value={user?.name || ''} className="bg-black/50 border-white/10 text-white mt-1.5" disabled data-testid="settings-name" />
            </div>
            <div>
              <Label className="text-white/60 text-sm">Email</Label>
              <Input value={user?.email || ''} className="bg-black/50 border-white/10 text-white mt-1.5" disabled data-testid="settings-email" />
            </div>
            <div>
              <Label className="text-white/60 text-sm">Account Type</Label>
              <Input value={user?.is_admin ? 'Administrator' : 'User'} className="bg-black/50 border-white/10 text-white mt-1.5" disabled />
            </div>
          </CardContent>
        </Card>

        <Card className="bg-white/[0.03] border-white/10 mb-6">
          <CardHeader>
            <CardTitle className="text-white text-lg">Token Balance</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-3xl font-bold text-amber-400" data-testid="settings-token-balance">{user?.token_balance || 0}</p>
                <p className="text-xs text-white/30">Available tokens</p>
              </div>
              <Button className="bg-indigo-600 hover:bg-indigo-500 text-white" onClick={() => navigate('/tokens')} data-testid="settings-buy-tokens-btn">
                Buy More Tokens
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-red-500/5 border-red-500/20">
          <CardHeader>
            <CardTitle className="text-red-400 text-lg">Danger Zone</CardTitle>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="border-red-500/30 text-red-400 hover:bg-red-500/10" onClick={logout} data-testid="settings-logout-btn">
              Sign Out
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
